import { agGridQuartzTheme } from '@amzn/gft-frontend-commons/styles';
import { useColorScheme } from '@mui/material/styles';
import { useMemo } from 'react';

/** Auriga-specific AG Grid overrides applied on top of shared library theme */
const aurigaGridOverrides = {
  // headerColumnResizeHandleDisplay: 'none',
  selectedRowBackgroundColor: 'transparent',
  cellFocusBorder: 'none',
  rangeSelectionBorderColor: 'transparent',
  // TODO: Verify these are still needed after visual check
  // cellHorizontalBorder: 'transparent',
  // cellFocusColor: 'transparent',
  // cellHorizontalPadding: 14,
} as const;

/**
 * Returns the AG Grid theme and the current theme mode for the `data-ag-theme-mode` attribute.
 *
 * @example
 * ```tsx
 * const { gridTheme, gridThemeMode } = useAgGridTheme();
 * <div className="ag-theme-mode" data-ag-theme-mode={gridThemeMode}>
 *   <AurigaGrid theme={gridTheme} ... />
 * </div>
 * ```
 */
export const useAgGridTheme = () => {
  const { mode } = useColorScheme();
  const gridThemeMode = mode === 'dark' ? 'dark' : 'light';
  const gridTheme = useMemo(() => agGridQuartzTheme.withParams(aurigaGridOverrides), []);

  return { gridTheme, gridThemeMode };
};
